module.exports = {
	"version": "1.2472.16",
	"manifest": {
		"a11yTestKit": "1.2396.57",
		"adminLoginButton": "1.2472.9",
		"animations": "1.2396.57",
		"audioCommon": "1.2396.57",
		"audioPlayer": "1.2472.9",
		"backToTopButton": "1.2472.9",
		"backgroundCommon": "1.2472.9",
		"balata": "1.2472.9",
		"bgImageStrip": "1.2472.9",
		"boxSlideShowSlide": "1.2472.9",
		"buttonCommon": "1.2396.57",
		"checkbox": "1.2472.9",
		"column": "1.2224.7",
		"comboBoxInput": "1.2472.9",
		"compDesignUtils": "1.2293.8",
		"compUtils": "1.2442.25",
		"components": "1.2472.9",
		"componentsPreviewLayer": "1.2472.9",
		"contactForm": "1.2472.9",
		"container": "1.2472.9",
		"containerCommon": "1.2472.9",
		"core": "1.2472.16",
		"coreUtils": "1.2472.9",
		"dataFixer": "1.2472.16",
		"datePicker": "1.2472.9",
		"dateUtils": "1.2224.7",
		"deadComponent": "1.2442.20",
		"dialogs": "1.2472.9",
		"displayer": "1.2472.9",
		"disqusComments": "1.2472.9",
		"documentMedia": "1.2472.9",
		"documentServices": "1.2472.16",
		"documentServicesSchemas": "1.2472.9",
		"editingRendererPlugins": "1.2224.7",
		"exitMobileModeButton": "1.2472.9",
		"facebookComments": "1.2472.9",
		"facebookLike": "1.2472.9",
		"facebookLikeBox": "1.2442.20",
		"facebookShare": "1.2472.9",
		"fileUploader": "1.2472.9",
		"flashComponent": "1.2472.9",
		"flickrBadgeWidget": "1.2472.9",
		"fonts": "1.2396.57",
		"fontsPrefetch": "1.2224.7",
		"formCommon": "1.2472.9",
		"galleriesCommon": "1.2335.3",
		"googleMap": "1.2472.9",
		"gridComponent": "1.2472.9",
		"groupContainer": "1.2442.20",
		"hoverBox": "1.2224.7",
		"htmlComponent": "1.2472.9",
		"image": "1.2472.9",
		"imageButton": "1.2472.9",
		"imageClientApi": "1.2224.7",
		"imageCommon": "1.2396.57",
		"imageZoom": "1.2472.9",
		"imageZoomDisplayer": "1.2472.9",
		"itunesButton": "1.2472.9",
		"languageSelector": "1.2472.9",
		"layout": "1.2472.16",
		"linkBar": "1.2472.9",
		"loggingUtils": "1.2472.16",
		"loginButton": "1.2472.9",
		"loginSocialBar": "1.2472.9",
		"matrixGallery": "1.2472.9",
		"mediaCommon": "1.2472.9",
		"mediaContainerFactory": "1.2367.7",
		"mediaControls": "1.2472.9",
		"mediaPlayer": "1.2472.9",
		"mediaZoom": "1.2472.9",
		"memoizeAPI": "1.2350.4",
		"menuButton": "1.2472.9",
		"messageView": "1.2472.9",
		"mobileActionsMenu": "1.2472.9",
		"multilingual": "1.2442.20",
		"page": "1.2472.9",
		"paypalButton": "1.2472.9",
		"pinItPinWidget": "1.2472.9",
		"pinterestFollow": "1.2472.9",
		"pinterestPinIt": "1.2472.9",
		"popupCloseTextButton": "1.2442.20",
		"popupContainer": "1.2442.20",
		"previewExtensionsCore": "1.2224.7",
		"qaAutomation": "1.2472.9",
		"quickActionBar": "1.2472.16",
		"radioButton": "1.2472.9",
		"radioGroup": "1.2472.9",
		"render": "1.2442.20",
		"repeater": "1.2472.9",
		"rssButton": "1.2472.9",
		"santaPreview": "1.2326.5",
		"santaProps": "1.2472.9",
		"singleAudioPlayer": "1.2472.9",
		"siteBackground": "1.2472.9",
		"siteRegionContainer": "1.2472.9",
		"siteUtils": "1.2472.9",
		"skinExports": "1.2472.9",
		"skins": "1.2472.9",
		"skypeCallButton": "1.2472.9",
		"slideShowGallery": "1.2472.9",
		"socialCommon": "1.2350.4",
		"soundCloudWidget": "1.2472.9",
		"spotifyFollow": "1.2472.9",
		"spotifyPlayer": "1.2472.9",
		"stripColumnsContainer": "1.2442.20",
		"stripContainer": "1.2442.20",
		"stripSlideShow": "1.2472.9",
		"stripSlideShowSlide": "1.2472.9",
		"subscribeForm": "1.2472.9",
		"svgCommon": "1.2472.9",
		"svgShape": "1.2472.9",
		"table": "1.2442.20",
		"testUtils": "1.2472.11",
		"textArea": "1.2442.20",
		"textCommon": "1.2472.9",
		"tinyMenu": "1.2472.9",
		"tpa": "1.2472.9",
		"tpaGalleries": "1.2472.9",
		"translationsUtils": "1.2472.9",
		"tweenEngine": "1.2224.7",
		"twitterFeed": "1.2472.9",
		"utils": "1.2472.9",
		"vKShareButton": "1.2472.9",
		"verticalAnchorsMenu": "1.2472.9",
		"verticalMenu": "1.2472.9",
		"wGooglePlusOne": "1.2472.9",
		"wTwitterFollow": "1.2472.9",
		"wTwitterTweet": "1.2472.9",
		"warmup": "1.2472.11",
		"widgets": "1.2472.9",
		"wixCode": "1.2472.9",
		"wixCodeInit": "1.2472.9",
		"wixCodeSeo": "1.2442.20",
		"wixSites": "1.2472.9",
		"wixappsBuilder": "1.2472.9",
		"wixappsClassics": "1.2472.9",
		"wixappsCore": "1.2472.9",
		"youTubeSubscribeButton": "1.2472.9",
		"zoomedImage": "1.2442.20"
	},
	"versions": {
		"mobx": "3.2.2",
		"mobxReact": "4.2.2",
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"a11yTestKit",
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"balata",
		"bgImageStrip",
		"boxSlideShowSlide",
		"buttonCommon",
		"checkbox",
		"column",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"dialogs",
		"displayer",
		"disqusComments",
		"documentMedia",
		"documentServices",
		"documentServicesSchemas",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"facebookShare",
		"fileUploader",
		"flashComponent",
		"flickrBadgeWidget",
		"fonts",
		"fontsPrefetch",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"gridComponent",
		"groupContainer",
		"hoverBox",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"imageZoom",
		"imageZoomDisplayer",
		"itunesButton",
		"languageSelector",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"loginSocialBar",
		"matrixGallery",
		"mediaCommon",
		"mediaContainerFactory",
		"mediaControls",
		"mediaPlayer",
		"mediaZoom",
		"memoizeAPI",
		"menuButton",
		"messageView",
		"mobileActionsMenu",
		"multilingual",
		"page",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"quickActionBar",
		"radioButton",
		"radioGroup",
		"render",
		"repeater",
		"rssButton",
		"santaPreview",
		"santaProps",
		"singleAudioPlayer",
		"siteBackground",
		"siteRegionContainer",
		"siteUtils",
		"skinExports",
		"skins",
		"skypeCallButton",
		"slideShowGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShow",
		"stripSlideShowSlide",
		"subscribeForm",
		"svgCommon",
		"svgShape",
		"table",
		"testUtils",
		"textArea",
		"textCommon",
		"tinyMenu",
		"tpa",
		"tpaGalleries",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"vKShareButton",
		"verticalAnchorsMenu",
		"verticalMenu",
		"wGooglePlusOne",
		"wTwitterFollow",
		"wTwitterTweet",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"youTubeSubscribeButton",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/main/options/viewer.json
// module id = 28
// module chunks = 0